import { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';
import { fetchElections } from '@/lib/api';
import type { Election } from '@/lib/types';
import { cn } from '@/lib/utils';

interface HeaderProps {
  selectedElection: Election | null;
  onElectionChange: (election: Election) => void;
}

export function Header({ selectedElection, onElectionChange }: HeaderProps) {
  const [elections, setElections] = useState<Election[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchElections()
      .then((data) => {
        setElections(data);
        if (data.length > 0 && !selectedElection) {
          onElectionChange(data[0]);
        }
      })
      .catch(console.error)
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <header className="bg-white border-b border-border px-6 py-4 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-bold text-foreground">Nepal Electoral Map</h1>
          <span className="text-sm text-muted-foreground">Parliamentary Constituencies</span>
        </div>

        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <Calendar className="w-5 h-5 text-muted-foreground" />
            <span className="text-sm font-medium text-muted-foreground">Election Year:</span>
          </div>
          
          {isLoading ? (
            <div className="h-10 w-32 bg-muted animate-pulse rounded-md" />
          ) : (
            <div className="flex gap-2">
              {elections.map((election) => (
                <button
                  key={election.id}
                  onClick={() => onElectionChange(election)}
                  className={cn(
                    'px-4 py-2 rounded-md text-sm font-medium transition-colors',
                    selectedElection?.id === election.id
                      ? 'bg-primary text-primary-foreground shadow-sm'
                      : 'bg-secondary text-secondary-foreground hover:bg-secondary/80'
                  )}
                >
                  {election.yearBs} BS ({election.yearAd})
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
